module.exports = __webpack_public_path__ + "img/smart-farming-pure-logo.27902f31.png";